import { useLayoutEffect } from "react";

import { Winda } from "../utils/Winda";

/**
 * Small wrapper around useLayoutEffect that is a noOp in SSR contexts.
 */
const useIsomorphicLayoutEffect = Winda.isPresent
  ? useLayoutEffect
  : () => void 0;

export default useIsomorphicLayoutEffect;
